import { IIngredient } from './../../interfaces/index';
import { indexOfCb } from '@/utils';
import { MainState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const getters = {
    hasAdminAccess: (state: MainState) => {
        return (
            state.userProfile &&
            state.userProfile.is_superuser && state.userProfile.is_active);
    },
    hasManagementAccess: (state: MainState) => {
        return (
            state.userProfile &&
            state.userProfile.is_owner);
    },
    loginError: (state: MainState) => state.logInError,
    dashboardShowDrawer: (state: MainState) => state.dashboardShowDrawer,
    dashboardMiniDrawer: (state: MainState) => state.dashboardMiniDrawer,
    userProfile: (state: MainState) => state.userProfile,
    token: (state: MainState) => state.token,
    isLoggedIn: (state: MainState) => state.isLoggedIn,
    firstNotification: (state: MainState) => state.notifications.length > 0 && state.notifications[0],
    userPhotoProfile: (state: MainState) => state.userPhotoProfile,
    selectedAccount: (state: MainState) => state.selected_account,
    employeeProfile: (state: MainState) => state.employeeProfile,
    ownerProfile: (state: MainState) => state.ownerProfile,
    selectedBranch: (state: MainState) => state.selectedBranch,
    uploadedMedia: (state: MainState) => state.mediaUploaded,
    currentAccount: (state: MainState) => state.currentAccount,
    defaultLanguage: (state: MainState) => state.defaultLanguage,
    defaultCurrency: (state: MainState) => state.defaultCurrency,
    loginErrorCause: (state: MainState) => state.logInErrorCause,
    autoCompleteIngredients: (state: MainState) => state.autoCompleteIngredients,
    ingredients: (state: MainState) => state.ingredients,
    ingredientById: (state: MainState) => (id: number) => {
        let idx = indexOfCb(state.ingredients, (ingredient: IIngredient) => {
            return ingredient.id === id;
        });
        if(idx >= 0){
            return state.ingredients[idx];
        }
    },
    currentSelectedBranch: (state: MainState) => state.currentSelectedBranch,
    showOverlayLoadingIndicator: (state: MainState) => state.showOverlayLoadingIndicator,
    currentSponsor: (state: MainState) => state.currentSponsor,
};

const {read} = getStoreAccessors<MainState, State>('');

export const readDashboardMiniDrawer = read(getters.dashboardMiniDrawer);
export const readDashboardShowDrawer = read(getters.dashboardShowDrawer);
export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readLoginError = read(getters.loginError);
export const readToken = read(getters.token);
export const readUserProfile = read(getters.userProfile);
export const readFirstNotification = read(getters.firstNotification);
export const readUserPhoto = read(getters.userPhotoProfile);
export const readHasManagementAccess = read(getters.hasManagementAccess);
export const readSelectedAccount = read(getters.selectedAccount);
export const readEmployeeProfile = read(getters.employeeProfile);
export const readOwnerProfile =  read(getters.ownerProfile);
export const readSelectedBranch = read(getters.selectedBranch);
export const readUploadedMedia = read(getters.uploadedMedia);
export const readCurrentAccount = read(getters.currentAccount);
export const readIngredients = read(getters.ingredients);
export const readDefaultLanguage = read(getters.defaultLanguage);
export const readDefaultCurrency = read(getters.defaultCurrency);
export const readLoginErrorCause = read(getters.loginErrorCause);
export const readAutoCompleteIngredients = read(getters.autoCompleteIngredients);
export const readIngredientById = read(getters.ingredientById);
export const readCurrentSelectedBranch = read(getters.currentSelectedBranch);
export const readShowOverlayLoadingIndicator = read(getters.showOverlayLoadingIndicator);
export const readCurrentSponsor = read(getters.currentSponsor);